import { createFileRoute } from "@tanstack/react-router";
import {
    kennelDashboardRoute,
    KennelDashboardLayout,
} from "@/features/provider-home";

export const Route = createFileRoute("/kennel/_dashboard")({
    ssr: kennelDashboardRoute.ssr,
    component: KennelDashboardLayout,
});
